import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const STORAGE_KEY = 'tenant_slug';
const RESERVED = ['admin', 'auth'];

export interface ITenantInfo {
  id: number;
  name: string;
  slug: string;
  logo_url: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  constructor(private http: HttpClient) {}

  getCurrentInfo(): Observable<ITenantInfo> {
    return this.http.get<{ tenant: ITenantInfo }>(`${environment.apiUrl}tenant/info`).pipe(
      map(res => res.tenant)
    );
  }

  getSlug(): string {
    const fromUrl = location.pathname.split('/').filter(Boolean)[0];
    if (fromUrl && !RESERVED.includes(fromUrl)) {
      localStorage.setItem(STORAGE_KEY, fromUrl);
      return fromUrl;
    }
    return localStorage.getItem(STORAGE_KEY) || environment.tenantSlug || '';
  }

  setSlug(slug: string): void {
    localStorage.setItem(STORAGE_KEY, slug);
  }

  clearSlug(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}
